
import Cookies from 'js-cookie'
import me from '~/store/me'
import store from '@/store'
import api from '~/api'
import { Base64 } from 'js-base64';
import moment from 'moment';
import { toLogin } from './jwt';
const Diff = require('diff');

import Vuex, { mapActions } from 'vuex'

export async function dealSignatrue(payload) {
  return payload
  let userInfo = await getUserInfo()
  let params = {
    public_key: userInfo.publicKey,
    nonce: new Date().getTime(),
    ...payload
  }
  let signature = getSignature(params, userInfo.privateKey)
  params.signature = signature
  return params
}

// 复制文本到剪贴板
export function copyToClip(content, callback) {
  let aux = document.createElement("input");
  aux.setAttribute("value", content);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
  callback && callback()
}

// 防抖函数
export function debounce(func, delay) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function getSignature(params, privateKey) {
  let md5 = require('js-md5')
  let str = ''

  const ordered = {}
  Object.keys(params).sort().forEach(function (key) {
    ordered[key] = params[key]
  })
  ordered.private_key = privateKey
  for (let key in ordered) {
    // 去掉空值参数
    if (ordered[key] || ordered[key] === 0) {
      if (str !== '') {
        str += '&'
      }
      str += key + '=' + ordered[key]
    }
  }
  return md5(str)
}

export async function getUserInfo() {
  let _t = Cookies.get('_t');
  let userJWT = { Authorization: _t }
  if (!userJWT.Authorization) {
    return {
      publicKey: '',
      privateKey: '',
      Authorization: userJWT.Authorization
    }
  }
  else {
    store.commit('me/IS_LOGIN', true)
    return {
      publicKey: '',
      privateKey: '',
      Authorization: userJWT.Authorization
    };
  }

}

export function getUserAgent(string) {
  return navigator.userAgent.toLocaleLowerCase().includes(string)
}
/**
 * 打开老项目页面
 * @param {string} path 路径
 * @param {string} targer 打开方式 _blank or blank
 */
export async function routerTo(path, target) {
  // 拼接path
  let reg = /^http/gim
  // if (!reg.test(path)) {
  //   path = process.env.NODE_ENV == 'development' ? process.env.HOST_ROOT + path : path
  // }
  // 跳转登陆返回
  let loginReg = /\/signin/gim;
  if (loginReg.test(path)) {
    Cookies.remove('_t');
    let location = window && window.location
    let url = location.hash ? location.pathname + location.hash : location.pathname + location.search;
    // cookie中插入返回的url
    await toLogin({login:true})
  }
  // 跳转方式
  if (target === 'blank' || target === '_blank') {
    if (document) {
      let a = document.createElement('a');
      a.setAttribute('target', '_blank');
      a.setAttribute('href', path);
      a.click();
    }
    else if (window) {
      let w = window.open();
      w.location.href = path
    }
    else {
      window && window.open(path, '_blank');
    }
  } else {
    // if (process.client) {
      window.location.href = path
    // }
  }
}

/**
 * 登陆拦截方法
 * @param {Function} callback
 */
export async function auth(callback) {
  let info = await getUserInfo();
  if (callback) {
    callback(info)
    return false
  }
  if (!info.publicKey && !info.Authorization) {
    routerTo('/signin?type=login')
  }
}


export function random(min, max) {
  return ~~(Math.random() * (max - min + 1) + min)
}

export const getCookie = req => {
  let decodedCookie
  if (typeof window === 'undefined') decodedCookie = decodeURIComponent(req.headers.cookie)
  else decodedCookie = decodeURIComponent(document.cookie)
  return decodedCookie
}

export const getAbsolute = function (reference, target) {
  //因为我们会将目标元素的边框纳入递归公式中，这里先减去对应的值
  var result = {
    left: - target.clientLeft,
    top: -target.clientTop
  }
  var node = target;
  while (node != reference && node != document) {
    result.left = result.left + node.offsetLeft + node.clientLeft;
    result.top = result.top + node.offsetTop + node.clientTop;
    node = node.parentNode;
  }
  if (isNaN(reference.scrollLeft)) {
    result.right = document.documentElement.scrollWidth - result.left;
    result.bottom = document.documentElement.scrollHeight - result.top;
  } else {
    result.right = reference.scrollWidth - result.left;
    result.bottom = reference.scrollHeight - result.top;
  }
  return result;
}

//获取cookie中的值
export const getCookieValue = (cookieName, $cookies) => {
  let cookieValue = '';
  if (!$cookies) {
    let cookies = document.cookie.split(";");
    cookies.length && cookies.forEach(item => {
      let items = item.split("=");
      if (items[0].trim() === cookieName) {
        cookieValue = items[1].trim();
      }
    })
  } else {
    cookieValue = $cookies.get(cookieName) || ''
  }
  return cookieValue
}

// 计算工作年限
export const workingYears = (profession_identity, workTime) => {
	if (!profession_identity) {
		return ''
	}
	if (workTime > 0) {
		return workTime > 20 ? 20 + '年以上经验' : workTime + '年经验'
	} else {
		return profession_identity || ''
	}
}

// 获取用户_t中的信息
export const get_tUser = () => {
  let _t = getCookieValue('_t'); //获取cookie中的_t
  let User = {};
  if (_t) {
    try {
      let value = Base64.decode(_t.split('.')[1]);
      if (value) {
        User = JSON.parse(value).User;
      }
    } catch (error) {
      
    }
  }
  return User;
}


//将base64转换为blob
export const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
//将blob转换为file
export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}

/**
 * 格式化时间
 * @param {*} time
 */
export const timeFormatFilter = (time) => {
  if(!time){
    return ''
  }
  let today = moment().format('YYYYMMDD')
  let update = moment(time).format('YYYYMMDD')
  let year = moment().year()
  let updateYear = moment(time).year()
  if (today === update) {
    return moment(time).format('HH:mm')
  } else if (update - 0 === today - 1) {
    return '昨天'
  } else if (update < today - 1 && year === updateYear) {
    return moment(time).format('MM月DD日')
  } else if (updateYear < year) {
    return moment(time).format('YYYY年MM月DD日')
  }
}
export const isSupportFontFamily =(f)=>{if(typeof f!="string"){return false}var h="Arial";if(f.toLowerCase()==h.toLowerCase()){return true}var e="a";var d=100;var a=100,i=100;var c=document.createElement("canvas");var b=c.getContext("2d");c.width=a;c.height=i;b.textAlign="center";b.fillStyle="black";b.textBaseline="middle";var g=function(j){b.clearRect(0,0,a,i);b.font=d+"px "+j+", "+h;b.fillText(e,a/2,i/2);var k=b.getImageData(0,0,a,i).data;return[].slice.call(k).filter(function(l){return l!=0})};return g(h).join("")!==g(f).join("")};

// 设置编辑次数
const storage = localStorage
export const setEditNumLocalStorage = () => {
  let num = parseInt(storage.getItem('editNumber') || 0)
  store.commit('editor/setEditNumber', num + 1)
  storage.setItem('editNumber', num + 1)
}

// check和添加时的resume翻页和滚动
export const dealResumeDomScroll = (els) => {
  const resumeEl = document.querySelector('.is-page-margin')
  const pageEl = document.querySelector('.resume')
  if (els && els.length) {
    // 所点击的dom元素距离浏览器顶部的高度 减去 简历距离浏览器顶部的位置 为 所点击dom距离简历顶部的高度
    let clickElOffsetTop = els[0].getBoundingClientRect().top - resumeEl.getBoundingClientRect().top
    // 一页纸的高度
    let pageElHeight = pageEl.clientHeight
    // 确定所点击dom在简历的第几页
    let pageIndex = Math.floor(clickElOffsetTop / pageElHeight) + 1
    return { pageIndex, pageElHeight }
  } else {
    return 1
  }
}

// 设置vuex编辑次数
export const setEditNumVuex = () => {
  let num = parseInt(storage.getItem('editNumber') || 0)
  store.commit('editor/setEditNumber', num)
}

//【JWT】更新jwt时间
export const updateJWT = async (data,callback)=>{
  let { jwt, jwt_timestamp='' } = data;
  console.log(jwt, "======================>lalala")
  let { pathname, hostname } = window.location;
  let endData = new Date();
  if(jwt_timestamp){
    endData.setTime(jwt_timestamp*1000);//过期时间
  }else{
    jwt_timestamp = parseInt(new Date().getTime()/1000) + 14 * 24 * 60 * 60;
    endData.setTime(endData.getTime() + 14 * 24 * 60 * 60 * 1000);//过期时间 15天
  }
  document.cookie = `_t=${jwt}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  document.cookie = `_t_at=${jwt_timestamp}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  let user = get_tUser();
  localStorage.setItem('_c_t', user.c_t || '');
  callback && callback()
}

//对比输入前后的内容
export const contrastContent = (newContent, oldContent) => {
  let reg=/<\/?.+?\/?>/g;
  let newValue = newContent.replace(reg,'').replace(/[\n]/g, "").replace(/&nbsp;/g, '').replace(' ', '');
  let oldValue = oldContent.replace(reg,'').replace(/[\n]/g, "").replace(/&nbsp;/g, '').replace(' ', '');
  const diff = Diff.diffChars(newValue, oldValue)
  let content = ''
  diff.forEach((part, index) => {
    if(index === 0){
      content = part.value
    }
    if(part.removed){
      content += part.value
    }
  });
  return content.replace(reg,'')
  // let startIndex = 0
  // let endIndex =  0
  // if(newValue === oldValue){
  //   return ''
  // }
  //
  // // if( newValue.length >= oldValue.length ){
  // endIndex = newValue.length - 1
  // for (let i = 0; i < newValue.length; i++){
  //   if(newValue[i] !== oldValue[i]){
  //     startIndex = i
  //     break
  //   }
  // }
  //
  // for (let i = 1; i < newValue.length; i++){
  //   if(newValue[newValue.length - i] !== oldValue[oldValue.length - i]){
  //     endIndex = newValue.length - i + 1
  //     break
  //   }
  // }
  //
  // let keyword = newValue.substring(startIndex, endIndex)
  // if( !keyword ) {
  //   let content = newValue.substr(0, endIndex)
  //   return  content
  // } else {
  //   let content = newValue.substr(0, newValue.indexOf(keyword) + keyword.length)
  //   return  content
  // }


  // } else if( newValue.length < oldValue.length ){
  //   endIndex = oldValue.length - 1
  //   for (let i = 0; i < oldValue.length; i++){
  //     if(newValue[i] !== oldValue[i]){
  //       startIndex = i
  //       break
  //     }
  //   }
  //   for (let i = 1; i < oldValue.length; i++){
  //     if(newValue[newValue.length - i] !== oldValue[oldValue.length - i]){
  //       endIndex = oldValue.length - i + 1
  //       break
  //     }
  //   }
  //   let keyword = oldValue.substring(startIndex, endIndex)
  //   console.log(keyword)
  //   let content = oldValue.substr(0, oldValue.indexOf(keyword))
  //   return content
  // }
}

//处理尾部标点符号
export const punctuationText = (text) =>{
  let punctuationList = [',', '，', '。', '.', '!', '！', '；', ';', '、', '\\', '：', ':']
  if( text.length > 0 ){
    let lastStr = text[text.length - 1]
    if(!punctuationList.includes(lastStr)){
      text = text + '，'
    }
  }
  return text
}

const company_scale_options = [ //公司规模数据
  {
    value: '0,19',
    max:19,
    label: '20人以下'
  }, {
    value: '20,99',
    max:99,
    label: '20-99人'
  }, {
    value: '100,499',
    max:499,
    label: '100-499人'
  }, {
    value: '500,999',
    max:999,
    label: '500-999人'
  }, {
    value: '1000,9999',
    max:9999,
    label: '1000-9999人'
  }, {
    value: '10000,999999',
    max:1000000,
    label: '10000人以上'
  }
]
// 获取公司规模
export const getCompanyScale = (size_min, size_max) =>{
  let scale = ''
  if(!size_max){
    return ''
  }
  company_scale_options.forEach(item=>{
    if(size_max <= item.max && !scale){
      scale = item.label
    }
  })
  return scale
}

// 获取用户会员状态
export const userMemberCheck = (value) => {
  let m1 = moment()
  let m2 = moment(value)
  let day = m2.diff(m1, 'day')
  if (!value) {
    // 不是会员
    return 'null'
  } else if (day >= 15000) {
    // 终身会员
    return 'life'
  } else if (day < 0) {
    // 已过期
    return 'timeout'
  } else {
    // 超级会员
    return 'super'
  }
}

// 校招时间
export const recruitmentTime = (item) => {
 
  if(!item) return ''
  if(!!item.net_apply_end_time) {
    let timeCount = parseInt(new Date(moment(item.net_apply_end_time).add(8,'h').format('YYYY-MM-DD')).valueOf() - new Date(moment().format('YYYY-MM-DD')).valueOf()) / (24*60*60*1000)
    if(timeCount >=0 && timeCount <= 30){
      item.display_time = `网申截止倒计时 ${parseInt(timeCount)} 天`
    } else {
      item.display_time = `截止投递：` + moment(item.net_apply_end_time).add(8,'h').format('YYYY-MM-DD')
    }
  } else if(!!item.net_apply_start_time) {
    item.display_time = '网申开始：' + moment(item.net_apply_start_time).add(8,'h').format('YYYY-MM-DD')
  } else {
    item.display_time = '发布时间：' + moment(item.created_at).add(8,'h').format('YYYY-MM-DD')
  }
  return item.display_time
  // let key = ['to_end_day','end_time','gt_end_time','net_apply_start_time','create_time'].find(key => {
  //   return typeof val[key] === 'string' || (val[key] >= 0)
  // })
  // if(key == 'to_end_day') {
  //   return `网申截止倒计时 ${val[key]} 天`
  // } else if(key == 'end_time' || key == 'gt_end_time' ) {
  //   return `截止投递：${moment(val[key]).format('YYYY-MM-DD')}`
  // } else if(key == 'net_apply_start_time') {
  //   return `网申开始：${moment(val[key]).format('YYYY-MM-DD')}`
  // } else if(key == 'create_time') {
  //   return `发布时间：${moment(val[key]).format('YYYY-MM-DD')}`
  // }
}

// openWindowView(url){
//   if(document.getElementById("openViewForm")){
//     document.getElementById("openViewForm").setAttribute('action', url);
//     document.getElementById("openViewForm").submit();
//   }else{
//     let formBox = document.createElement('form');
//         formBox.setAttribute('target', '_blank');
//         formBox.setAttribute('action', url);
//         formBox.setAttribute('method', 'get');
//         formBox.setAttribute('id', 'openViewForm');
//     document.body.appendChild(formBox);
//     setTimeout(() => {
//       document.getElementById("openViewForm").submit();
//     }, 10);
//   }
// }

export const displayBannerSaveHistory = async (bannerLength, storageField) => {
  try {
    if (!bannerLength) return console.log(`banner image length is 0`);
    let currentHistoryBannerData = localStorage.getItem(storageField);
    let currentDateString = new Date().toLocaleDateString();
    let [beforeMinus, afterMinus = 0] = (currentHistoryBannerData || '').split('-');

    const isDiffDate = beforeMinus !== currentDateString;
    isDiffDate && (afterMinus = 0);
    
    const isBannerState = isDiffDate || (!isDiffDate && +afterMinus < bannerLength);

    if (isBannerState) {
      afterMinus = +afterMinus + 1;
      localStorage.setItem(storageField, `${currentDateString}-${afterMinus}`)
      return afterMinus - 1;
    }
  } catch (error) {
    console.log(`display banner image error: ${error}`)
  }
}